import Section from '../ui/Section';

export default function Ventures() {
  return (
    <Section id="ventures" eyebrow="Ventures" title="New events and experiences.">
      <p>
        Brian has been at the forefront of creating new and innovative events and experiences for
        audiences, developing original concepts that bring people together.
      </p>
    </Section>
  );
}
